import axios from 'axios'

import store from '@/store'

export default {
  getItemDetail (payload) {
    let params = payload.paramsMode ? `${payload.path}/${payload.id}` : `${payload.path}?id=${payload.id}`
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => {
        if (response) {
          return response.data
        } else {
          throw new Error('apiCommons: "response" invalido')
        }
      })
      .catch(error => {
        throw error
      })
  },
  updateItemDetail (path, data) {
    return axios.post(path, data, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => {
        if (response) {
          return response.data
        }
      })
      .catch(error => {
        throw error
      })
  },
  deleteItem (path, data) {
    return axios.delete(path, { data: data }, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => {
        if (response) {
          return response.data
        } else {
          throw new Error('apiCommons: "response" invalido')
        }
      })
      .catch(error => {
        throw error
      })
  },
  getItems (payload) {
    let params = `${payload.path}?`
    if (payload.offset) {
      params += `&offset=${payload.offset}`
    }
    if (payload.limit) {
      params += `&limit=${payload.limit}`
    }
    if (payload.id) {
      params += `&id=${payload.id}`
    }
    if (payload.term) {
      params += `&term=${payload.term}`
    }
    if (payload.order) {
      params += `&order=${payload.order}`
    }
    if (payload.orderBy) {
      params += `&order_by=${payload.orderBy}`
    }
    if (payload.dateFrom) {
      params += `&date_from=${payload.dateFrom}`
    }
    if (payload.dateUpTo) {
      params += `&date_up_to=${payload.dateUpTo}`
    }
    if (payload.searchOnFields) {
      payload.searchOnFields.forEach(element => {
        params += `&search_on_fields=${element}`
      })
    }
    if (payload.aggregates) {
      payload.aggregates.forEach((element) => {
        let key = Object.keys(element)
        params += `&${key}=${element[key]}`
      })
    }
    if (payload.background) {
      params += `&background=true`
    }
    if (payload.format) {
      params += `&lml_format=${payload.format}`
    }
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => ({ data: response.data, params }))
      .catch(error => {
        throw error
      })
  },
  getTypeAhead (args) {
    let params = `${args.path}?term=${args.term}`
    if (args.parentId) {
      params += `&id=${args.parentId}`
    }
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => {
        if (response) {
          return response.data
        } else {
          throw new Error('apiCommons: "response" invalido')
        }
      })
      .catch(error => {
        throw error
      })
  },
  getSelectOptions (data = {}) {
    const {
      path,
      total = 500,
      parentId = null,
      ...extraArgs
    } = data

    if (!path) {
      return []
    }

    let params = total !== null ? `${path}?total=${total}` : `${path}`
    if (parentId !== null) {
      params += `&id=${parentId}`
    }
    // En caso que se reciban argumentos adicionales se construye el nuevo request
    // para pasarselo al endpoint
    if (extraArgs) {
      Object.keys(extraArgs).forEach(k => {
        params += `&${k}=${extraArgs[k]}`
      })
    }
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => {
        if (response) {
          if (response.data.items && response.data.items.length) {
            return response.data.items
          } else {
            return []
          }
        } else {
          throw new Error('apiCommons: "response" invalido')
        }
      })
      .catch(error => {
        throw error
      })
  },
  axiosGetWrapper (url) {
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
  },
  axiosDeleteWrapper (url) {
    return axios.delete(url, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
  },
  axiosPostWrapper (
    path,
    data = {},
    config = {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    }) {
    axios.post(path, data, config)
  }
}
